/**
 * MSW (Mock Service Worker) Request Handlers
 * Define mock API responses for testing
 */

import { http, HttpResponse } from 'msw';
import { getCookie } from 'src/modules/web-ui/utils/cookie-utils';

import { TEST_CREDENTIALS } from './handlers/constants';
import { handleLegacyPostApi } from './handlers/legacy-post-api';

/** Legacy POST /api + Web UI; REST auth is in handlers/auth-rest.ts when VITE_TEST_MODE. */
export const handlers = [
  http.post('*/api', async ({ request }) => {
    const raw = await request.text();
    const body = JSON.parse(raw) as {
      service?: string;
      access?: string;
      command?: string;
      parameters?: unknown;
    };

    const service = body.service ?? '';
    const command = body.command ?? '';
    const access = body.access ?? 'get';
    const userFromCookie = getCookie('user');

    if (!(service === 'user' && command === 'login')) {
      if (!userFromCookie) {
        return HttpResponse.json(
          { error: 'No active Session' },
          { status: 401 },
        );
      }
      if (
        access === 'set' &&
        TEST_CREDENTIALS.find((cred) => cred.user === userFromCookie)
          ?.userLevel === '1'
      ) {
        return HttpResponse.json({ msg: 'invalid rights' }, { status: 403 });
      }
    }

    return handleLegacyPostApi(body, userFromCookie);
  }),
];
